import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import { media, colors } from '../../styles/constants';

import { renderPossiblyOptimizedImage } from '../../helpers/images';
import { parseShortcodeArray } from '../../helpers/shortcode';

const CircleSvg = styled.svg`
  position: absolute;
  z-index: -1;
  width: 115%;
  min-width: 15rem;
  max-width: 25rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: ${media.tabletLandscape}) {
    max-width: 30rem;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE doesn't scale like the others */
    min-height: 140%;
  }
`;

const Circle = ({ color }) => (
  <CircleSvg viewBox="0 0 301 301">
    <circle
      fill={color}
      opacity="0.9"
      cx="150.561102"
      cy="150.637432"
      r="150"
    />
  </CircleSvg>
);

Circle.propTypes = {
  color: PropTypes.string.isRequired
};

const CircleGroupContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 6rem auto 7rem;
  justify-content: center;
  max-width: 43rem;

  > div {
    min-height: 15rem;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 50%;

    @media (min-width: ${media.phone}) {
      min-height: 20rem;
    }
  }

  @media (min-width: ${media.tabletPortrait}) {
    flex-wrap: nowrap;
    max-width: none;
    max-height: auto;

    > div {
      min-height: 20rem;
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: 25%;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    margin-top: 10rem;
    margin-bottom: 9rem;
  }

  @media (min-width: ${media.desktop}) {
    margin-top: 11rem;
    margin-bottom: 11rem;
  }
`;

const CircleContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 25rem;

  div {
    margin: auto auto;

    img,
    svg,
    span {
      max-width: 14rem;
      max-height: 8.5rem;

      @media (min-width: ${media.phone}) {
        max-width: 17rem;
        max-height: 10rem;
      }

      @media (min-width: ${media.tabletPortrait}) {
        max-width: 15rem;
        max-height: 9rem;
      }

      @media (min-width: ${media.tabletLandscape}) {
        max-width: 19rem;
        max-height: 11.5rem;
      }
    }
  }
`;

const CircleGroup = ({ circles, optimizedImages }) => {
  const circlesArray = parseShortcodeArray(circles);

  return (
    <CircleGroupContainer>
      {circlesArray.map(({ image, color, ...props }, i) => {
        const circleColor = colors[color] ? colors[color] : color;
        return (
          <CircleContainer key={`circleGroup${i}`}>
            <div>
              {image.includes('.svg') ? (
                <SVG src={image}>
                  <img src={image} {...props} />
                </SVG>
              ) : (
                renderPossiblyOptimizedImage(
                  { src: image, ...props },
                  optimizedImages
                )
              )}
            </div>
            <Circle color={circleColor} />
          </CircleContainer>
        );
      })}
    </CircleGroupContainer>
  );
};

CircleGroup.propTypes = {
  circles: PropTypes.string.isRequired,
  optimizedImages: PropTypes.array
};

export default CircleGroup;
